<!-- 上边用户信息模块 -->
<template>
  <div class="box">
    <!-- 用户基本信息 -->
    <div class="base-info">
      <div class="name">{{ surname + user_name }}</div>
      <img
        class="sex"
        :src="
          !gender
            ? require('@/common/images/recommend/sex_nan_select.png')
            : require('@/common/images/recommend/sex_nv_select.png')
        "
        alt=""
      />
      <!-- <div class="phone" v-if="$route.query.status == '4'">
        {{ contact_number.replace(/^(\d{4})\d{4}(\d+)/, "$1****$2") }}
      </div> -->
      <div class="phone">{{ contact_number }}</div>
    </div>
    <!-- 用户需求信息 -->
    <div class="need-info">
      <div class="base-need">
        <div class="info formats" v-if="tagObj['需求业态']">
          {{ tagObj["需求业态"] }}
        </div>
        <div class="info area" v-if="tagObj['需求面积']">
          {{ tagObj["需求面积"] }}
        </div>
        <div class="info intention" v-if="tagObj['购房意向']">
          {{ tagObj["购房意向"] }}
        </div>
      </div>
      <div class="more" @click="goTags">
        <span>更多</span>
        <img
          class="more-icon"
          :src="require('@/common/images/recommend/forward.png')"
          alt=""
        />
      </div>
    </div>
    <!-- 备注部分 -->
    <div class="remark" v-if="isShowRemark">
      {{ remark }}
    </div>
    <!-- 展开备注功能按钮 -->
    <img
      v-if="remark"
      :src="
        !isShowRemark
          ? require('@/common/images/recommend/fold-up.png')
          : require('@/common/images/recommend/fold-on.png')
      "
      class="fold"
      @click="isShowRemark = !isShowRemark"
    />
    <!-- 用来把高度撑开 -->
    <div class="block"></div>
  </div>
</template>

<script>
export default {
  props: [
    "surname",
    "user_name",
    "recommend_id",
    "contact_number",
    "gender",
    "remark",
    "tagList",
  ],
  data() {
    return {
      isShowRemark: false, //是否显示备注
    };
  },
  computed: {
    tagObj() {
      let value = {};
      JSON.parse(JSON.stringify(this.tagList)).forEach((res) => {
        value[res.propertyName] = res.propertyValue;
      });
      return value;
    },
  },
  methods: {
    //更多标签
    goTags() {
      this.$router.push({
        name: "tagList",
        query: {
          tagList: this.tagList,
          id: this.recommend_id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  width: 690px;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0px 4px 20px 0px rgba(96, 139, 122, 0.3);
  border-radius: 40px 0px 40px 0px;
  padding: 30px 40px 16px;
  .base-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    .name {
      font-size: 48px;
    }
    .sex {
      width: 32px;
      height: 36px;
    }
    .phone {
      font-size: 32px;
    }
  }
  .need-info {
    display: flex;
    justify-content: space-between;
    margin-top: 36px;
    .base-need {
      .info {
        height: 48px;
        padding: 4px 20px;
        border-radius: 0px 12px 12px 12px;
        display: inline-block;
        margin-right: 12px;
        font-size: 24px;
        line-height: 40px;
        font-family: PingFangSC-Regular, PingFang SC;
        &.formats {
          background: #d8eee7;
          color: #007458;
        }
        &.area {
          background: #f6eed9;
          color: #d79414;
        }
        &.intention {
          background: #dde9f5;
          color: #5386b8;
        }
      }
    }
    .more {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      display: flex;
      align-items: center;
      .more-icon {
        width: 12px;
        height: 24px;
        margin-left: 10px;
        line-height: 28px;
      }
    }
  }
  .remark {
    margin-top: 24px;
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    word-break: break-word;
  }
  .fold {
    width: 32px;
    height: 16px;
    margin: 32px auto 0;
    display: block;
  }
}
</style>
